import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isPast } from 'date-fns';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { DotsLoader } from '@sorare/core/src/atoms/loader/DotsLoader';
import { css } from '@sorare/css';

import { AuctionBidsInfo } from '#src/components/auction/Auction/AuctionDetails/AuctionBidsInfo/index.tsx';
import { AuctionTimeLeft } from '#src/components/auction/AuctionTimeLeft/index.tsx';

import type { AuctionStatus_auction } from './__generated__/index.graphql.ts';

type Props = {
  auction: AuctionStatus_auction;
};

const root = css`
  font: var(--t-12);
  color: var(--c-nd-600);
  width: 100%;
  min-height: var(--triple-unit);
  flex-wrap: wrap;
`;

export const AuctionStatus = ({ auction }: Props) => {
  const { endDate } = auction;
  const ended = isPast(endDate);
  return (
    <Horizontal gap={0.5} className={root}>
      <AuctionBidsInfo auction={auction} />
      {' • '}
      {ended ? <DotsLoader small /> : <AuctionTimeLeft endDate={endDate} />}
    </Horizontal>
  );
};

AuctionStatus.fragments = {
  auction: gql`
    fragment AuctionStatus_auction on TokenAuction {
      id
      endDate
      ...AuctionBidsInfo_auction
    }
    ${AuctionBidsInfo.fragments.auction}
  ` as TypedDocumentNode<AuctionStatus_auction>,
};
